<template>
  <div class="index-additive-goods">
    <Header title="添加商品" :showRigIcon="false"></Header>
    <p class="index-additive-desc">请细心核对所有已发布的预置商品和问问商品的价格，避免在活动发布后造成损失，同个商品，不能同时参加多个活动；</p>
    <div>
      <!-- <div class="index-additive-tab">
                <span :class="{'tab-select': tabIndex == 1}" @click="onTabChange(1)">预置商品</span>
                <span :class="{'tab-select': tabIndex == 2}" @click="onTabChange(2)">问问商品</span>
            </div> -->
      <div class="index-additive-search">
        <van-search v-model="itemNameLike" shape="round" show-action :placeholder="`搜索商品名称`" @search="onSearch">
          <template #left-icon>
            <img class="search-img" src="../../assets/home/serchicon.png" />
          </template>
          <template #action>
            <div class="screen" @click="onPopupOpen">
              筛选
              <img src="../../assets/brand/shai@2x.png" />
            </div>
          </template>
        </van-search>
      </div>
      <div class="index-additive-contain">
        <div class="index-additive-checked">
          <van-checkbox ref="ckAll" v-model="ckAll" @change="toggleAll">
            全选
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
            </template>
          </van-checkbox>
          <div v-if="['1','2','3'].includes($route.query.status)" class="check-all" @click="onBatchAddClick">批量添加</div>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
          <van-list v-model="loading" :finished="finished" error-text="请求失败，点击重新加载" @load="onLoad">
            <div class="index-additive-list">
              <van-checkbox-group ref="checkboxGroup" v-model="checkList">
                <div class="index-additive-item" v-for="(item,index) in list" :key="index">
                  <div class="index-additive-ckbox">
                    <van-checkbox :name="index" @click.native="isCheckAll">
                      <template #icon="props">
                        <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
                      </template>
                    </van-checkbox>
                  </div>
                  <div class="index-additive-good">
                    <van-image class="goods-image" :src="item.indexImage.imageUrl"></van-image>
                    <div class="goods-content">
                      <div class="goods-desc">
                        <h5 class="goods-tt">{{item.itemName}}</h5>
                        <div class="goods-price">
                          <p class="goods-alprice">
                            <span>销售价：</span>
                            <i>￥{{item.price}}</i>
                          </p>
                          <p class="goods-dpprice">
                            <span>吊牌价：</span>
                            <i>￥{{item.markingPrice}}</i>
                          </p>
                          <p class="goods-zkprice" v-if="item.mostFavorablePrice || item.mostFavorablePrice==0">
                            <span>预估最高折扣价：</span>
                            <i>￥{{item.mostFavorablePrice}}</i>
                          </p>
                        </div>
                      </div>
                      <div class="goods-actions">
                        <span class="goods-status">{{item.upShelf == 'y' ? '已上架' : '已下架'}}</span>
                        <div>
                          <span v-if="['1','2','3'].includes($route.query.status)" class="goods-btn" @click="onGoodsAdd(item)">添加</span>
                          <span class="goods-btn btn-danger" @click="cursorFun(item.discountLadder &&  item.discountLadder.join(','))" :style="{'opacity':item.discountLadder? 1 : 0}">{{item.discountLadder &&  item.discountLadder.join(",")}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </div>

            <div class="index-additive-none" v-show="this.list.length==0">
              <img :src="$theme.general_icon_empty" />
              <p>暂无搜索结果</p>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!-- <FilterComp ref="filter" :categoryList="categoryList" @submit="onSubmit"></FilterComp> -->
    <FilterComp ref="filter" @callback="callbackOption"></FilterComp>
    <FixedBtn label="保存活动" @btnClick="onActivityOpen"></FixedBtn>
  </div>
</template>

<script>
import http from "@/utils/axios";
import FilterComp from './components/filter_comp';
import Header from './components/header';
import FixedBtn from "./components/fixed_btn";
export default {
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      ckAll: false,
      checkList: [],
      tabIndex: 1,
      pageIndex: 1,
      pageSize: 10,
      itemNameLike: '',
      list: [],
      categoryList: [],
      selectObj: {
        goodCategoryIdList: [],
        goodStatusList: []
      },
      discountActivityId: this.$route.query.id,
      batchAddLoading: false,
      branchNo:""
    }
  },
  created() {
    console.log(this.$theme);
    window["reloadData"] = (res) => {
      this.onLoad();
    };
    this.getCategoryList()
  },
  methods: {
    onActivityOpen(){
        this.$router.push({
            name: "discount_list"
        });
    },

    onSubmit(selectObj) {
      this.selectObj = selectObj
      this.onRefresh()
    },
    callbackOption(row) {
      console.log(row);
      this.selectObj = row
      // for (const key in row) {
      //     this.form[key] = row[key];
      // }
      // this.$emit("callback", true);
      // this.setInit();

      this.finished = false;
      this.refreshing = true;
      this.pageIndex = 1;
      this.loading = true;
      this.list = [];
      //   this.getCategoryList()
      this.onLoad();

    },

    onRefresh() {
      this.finished = false;
      this.refreshing = true;
      this.pageIndex = 1;
      this.loading = true;
      this.list = [];
      this.getCategoryList()
      this.onLoad();
    },
    onLoad() {
      http({
        url: "order/bee/goods/shopBranch",
        method: "POST",
        parmes: {},
      }).then((rps) => {
        rps.data.forEach((element) => {
          this.branchNo = element.branchId
        });
        this.getData()
      });


    },
    getCategoryList() {
      http({
        url: '/order/bees/discountActivity/goodCategory',
        method: 'post',
        parmes: {
          discountActivityId: this.$route.query.id || this.discountActivityId,
          goodType: this.tabIndex,
          isInvolved: 'n'
        }
      }).then(rps => {
        if (rps.code == 200) {
          this.categoryList = rps.data
        }
      })
    },
    getData() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      //   imageUrl goodName price discountType promotionType markingPrice mostFavorablePrice goodStatus discountInfo

      this.$loading.show();

      let params = {
          //   discountActivityId: this.$route.query.id || this.discountActivityId,
          //   goodType: this.tabIndex,
          //   pageIndex: this.pageIndex,
          //   pageSize: this.pageSize,
          //   goodName: this.goodName,
          //   isInvolved: 'n',
          //   ...this.selectObj

          // discountActivityId: this.$route.query.id || this.discountActivityId,
          // goodType: this.tabIndex,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          itemNameLike: this.itemNameLike,
          // isInvolved: 'y',

          isQuick: "n",
          isInvolved: "n",
          activityId: this.$route.query.id || this.discountActivityId,
          // branchNo:111,
          checkStatus: "FINISH",
          // buyType: 1,
          ...this.selectObj,
          branchNo: this.branchNo
      }
      if(this.$route.query.brandId){
        params.branchNo = this.$route.query.brandId
      }

      http({
        // url: '/order/bees/discountActivity/goodManagementList',
        // url: '/order/item/quick/bees/page',
        url: '/order/item/quick/mini/page', // 5.15日 产品和后端肖勇 要求更换接口
        method: 'post',
        parmes: params
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.length == 0) {
            this.finished = true;
          } else {
            this.list = this.list.concat(rps.data)
            this.pageIndex++;

            if (this.ckAll) {
              this.$nextTick(() => {
                this.toggleAll(true)
              })
            }
          }
          this.loading = false;
          this.$loading.hide();
        }
      })
    },
    onSearch() {
      this.onRefresh()
    },
    onBatchAddClick() {
      if (!this.checkList.length) {
        return this.$toast('请您选择需要批量处理的商品')
      }
      if (this.batchAddLoading) return;
      this.batchAddLoading = true;
      const goods = this.checkList.map(item => ({
        goodId: this.list[item].id,
        goodType: this.tabIndex
      }))
      this.onGoodsPatch(true, goods).finally(() => (this.batchAddLoading = false));
    },
    onGoodsAdd(item) {
      if (item.loading) return;
      item.loading = true;
      const goods = [{
        goodId: item.id,
        goodType: this.tabIndex
      }]
      this.onGoodsPatch(false, goods).finally(() => (item.loading = false));
    },
    onGoodsPatch(type, discountGoods) {
      let parmes = {
        discountActivityId: this.$route.query.id || this.discountActivityId,
        discountGoods: discountGoods
      }
      if (this.ckAll) {
        parmes.isSelectAll = 1;
        parmes.queryParam = {
          discountActivityId: this.$route.query.id || this.discountActivityId,
          goodType: this.tabIndex,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          itemNameLike: this.itemNameLike,
          isInvolved: 'n',
          ...this.selectObj
        }
      }
      return http({
        url: '/order/bees/discountActivity/good/add',
        method: 'put',
        parmes: parmes
        // {
        //     discountActivityId: this.$route.query.id,
        //     discountGoods,
        //     isSelectAll: this.ckAll ? 1 : 0
        // }
      }).then(rps => {
        if (rps.code == 200) {
          this.$toast(type ? '批量添加成功' : '添加成功')
          this.checkList = []
          this.onRefresh()
        }
      })

    },
    onPopupOpen() {
      //   this.$refs.filter.firstPopupStatus = true
      this.$refs.filter.show = true;
    },
    onTabChange(index) {
      if (this.tabIndex == index) return
      this.tabIndex = index
      this.selectObj = {
        goodCategoryIdList: [],
        goodStatusList: []
      }
      this.$refs.filter.selectStatusList = []
      this.$refs.filter.selectIdList = []
      this.$refs.ckAll.toggle(false)
      this.checkList = []
      this.onRefresh()
    },
    checkAll() {
      this.$refs.checkboxGroup.toggleAll(true)
    },
    toggleAll(event) {
      console.log(event);
      this.$refs.checkboxGroup.toggleAll(event)
    },
    isCheckAll() {
      setTimeout(() => {
        if (this.checkList.length == this.list.length) {
          this.$refs.ckAll.toggle(true)
        } else {
          this.$refs.ckAll.toggle(false)
        }
      }, 100)
    },
    cursorFun(text) {
      this.$toast(text);
    }
  },
  components: {
    FilterComp,
    Header,
    FixedBtn
  }
}
</script>

<style lang="less" scoped>
.index-additive-goods {
  font-size: 24px;
  background-color: #fff;

  .index-additive-desc {
    padding: 17px 30px 17px 40px;
    color: #fd9090;
    font-weight: 500;
    line-height: 33px;
    background-color: #fff9e1;
  }

  .index-additive-tab {
    display: flex;
    justify-content: space-around;
    height: 79px;
    span {
      // display: inline-block;
      position: relative;
      padding: 17px 0 25px;
      color: #999999;
      font-size: 26px;

      &.tab-select {
        color: #333;
      }

      &.tab-select::after {
        content: '';
        position: absolute;
        bottom: 10px;
        width: 79px;
        height: 5px;
        border-radius: 3px;
        background-color: #f8d541;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .index-additive-search {
    padding: 0 40px;
    border: 1px solid #f2f2f2;
    border-right: none;
    border-left: none;
    .screen {
      display: flex;
      align-items: center;
      font-size: 24px;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .search-img {
      width: 36px;
      height: 36px;
      vertical-align: text-bottom;
    }
  }
  .index-additive-contain {
    margin-bottom: 140px;
    .index-additive-checked {
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      padding: 0 30px 0 40px;
      .check-all {
        width: 140px;
        height: 50px;
        border-radius: 10px;
        border: 1px solid #999;
        color: #999;
        line-height: 50px;
        text-align: center;
        position: relative;
      }
      /deep/ .van-checkbox .van-checkbox__label {
        font-size: 28px;
        color: #999;
      }
    }
    .index-additive-list {
      background-color: #fff;
      .index-additive-item {
        display: flex;
        padding: 30px 30px 30px 40px;
        .index-additive-ckbox {
          display: flex;
          align-items: center;
        }
        .index-additive-good {
          flex: 1;
          display: flex;
          margin-left: 20px;
          .goods-image {
            width: 140px;
            height: 140px;
          }
          .goods-content {
            margin-top: 3px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            margin-left: 20px;
          }
          .goods-desc {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .goods-tt {
              max-width: 320px;
              font-weight: 500;
              line-height: 33px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .goods-alprice,
            .goods-dpprice,
            .goods-zkprice {
              font-size: 20px;
              color: #999;
              i {
                font-style: normal;
              }
            }
            .goods-alprice i {
              color: #ed3939;
            }
            .goods-zkprice i {
              color: #f8a651;
            }
          }
          .goods-actions {
            width: 135px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              display: block;
            }
            .goods-status {
              color: #f8a651;
              font-weight: 500;
              text-align: right;
            }
            .goods-btn {
              width: 135px;
              height: 40px;
              border-radius: 10px;
              font-weight: 500;
              background-color: var(--epButtonColor);
              color: var(--epTextColor);
              text-align: center;
              line-height: 40px;

              &.btn-danger {
                background-color: #ffe7e6;
                color: #ed3939;
                margin-top: 10px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .index-additive-none {
      width: 710px;
      height: 705px;
      margin: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex-direction: column;
      background-color: #fff;
      img {
        width: 220px;
        height: 220px;
      }
      p {
        font-size: 28px;
        line-height: 40px;
        margin: 44px 0 21px;
      }
      div {
        width: 160px;
        height: 60px;
        line-height: 60px;
        background-color: #f8d541;
        border-radius: 32px;
      }
    }
    .img-icon {
      width: 40px;
      height: 40px;
    }
  }
}
/deep/ .van-pull-refresh {
  background-color: #f7f7f7;
}
</style>